import gdGames from "./gdGames";
import gmGames from "./gmGames";

export const GAME_SOURCES = {
  gd: {
    key: "gd",
    name: "GD-Games",
    enabled: false,
    games: gdGames
  },
  gm: {
    key: "gm",
    name: "GM-Games",
    enabled: true,
    games: gmGames
  }
};

export const ACTIVE_GAME_SOURCE_KEY = "gm";
export const ACTIVE_GAME_SOURCE = GAME_SOURCES[ACTIVE_GAME_SOURCE_KEY] || GAME_SOURCES.gm;
export const ACTIVE_GAME_SOURCE_NAME = ACTIVE_GAME_SOURCE.name;

const games = ACTIVE_GAME_SOURCE.games;

export default games;
